import { render, staticRenderFns } from "./PdfDocumentCreateNav.vue?vue&type=template&id=40fa4fbf&scoped=true&"
import script from "./PdfDocumentCreateNav.vue?vue&type=script&lang=js&"
export * from "./PdfDocumentCreateNav.vue?vue&type=script&lang=js&"
import style0 from "./PdfDocumentCreateNav.vue?vue&type=style&index=0&id=40fa4fbf&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fa4fbf",
  null
  
)

export default component.exports